<div class="container text-center mt-4">
  <div class="row">
    <div class="col text-start card-background p-4">
      <div class="card">
        <h1>Privacy Policy</h1>
        <ol>
          <li>
            <h2>Introduction</h2>
            <ul>
              <li>
                <h3>Purpose:</h3>
                <ul>
                  <li>This Privacy Policy explains how Meal Planner collects, uses, and discloses your personal information.</li>
                  <li>This Privacy Policy applies to the Meal Planner website.</li>
                  <li>Contact Information:** If you wish to inquire about this policy you can do so via our <a class="link-opacity-100" href="/contact">contact page</a>.</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h2>Information Collection</h2>
            <ul>
              <li>
                <h3>Types of Information Collected:</h3>
                <ul>
                  <li>
                    <h4>Personally Identifiable Information (PII):</h4>
                    <ul>
                      <li>Name</li>
                      <li>Email Address</li>
                    </ul>
                  </li>
                  <li>
                    <h4>Non-Personally Identifiable Information:</h4>
                    <ul>
                      <li>Cookies</li>
                    </ul>
                  </li>
                  <li>
                    <h4>Methods of Collection:</h4>
                    <ul>
                      <li>Website registration forms</li>
                      <li>Cookies</li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h2>Use of Information</h2>
            <ul>
              <li>
                <h3>How Information is Used:</h3>
                <ul>
                  <li>Provide services</li>
                  <li>Process orders</li>
                  <li>Communicate with users</li>
                  <li>Improve website functionality</li>
                  <li>Personalize user experience</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </li>
              <li>
                <h3>Data Sharing:</h3>
                <ul>
                  <li>
                    Your data will not be shared with third parties unless required by law or necessary for the provision of services. In such cases, we will obtain your consent before sharing your data.
                  </li>
                </ul>
              </li>
              <li>
                <h3>Data Transfers:</h3>
                <ul>
                  <li>Your data will not be transfered.</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h2>Data Security</h2>
            <ul>
              <li>
                <h3>Measures to Protect Data:</h3>
                <ul>
                  <li>Encryption</li>
                  <li>Access controls</li>
                  <li>Firewalls</li>
                  <li>Regular security audits</li>
                  <li>Employee training</li>
                </ul>
              </li>
              <li>
                <h3>Data Breaches:</h3>
                <ul>
                  <li>Explain how you will handle data breaches, including notification procedures.</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h2>User Rights</h2>
            <ul>
              <li>
                <h3>Data Access and Control:</h3>
                <ul>
                  <li>Access their personal information.</li>
                  <li>Request correction of inaccurate information.</li>
                  <li>Request deletion of their personal information.</li>
                  <li>Restrict or object to the processing of their data.</li>
                  <li>Data portability (if applicable).</li>
                </ul>
              </li>
              <li>
                <h3>How to Exercise Rights:</h3>
                <ul>
                  <li>Provide clear instructions on how users can exercise their rights (e.g., contact information, online forms).</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h2>Changes to this Policy</h2>
            <ul>
              <li>
                <h3>Policy Updates:</h3>
                <ul>
                  <li>Explain that this policy may be updated periodically.</li>
                  <li>Include information on how users will be notified of any changes.</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h2>Governing Law</h2>
            <ul>
              <li>Specify the governing law and jurisdiction.</li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col text-start card-background p-4">
      <div class="card">
        <h1>Cookie Policy</h1>
        <ol>
          <li>
            <h2>Introduction</h2>
            <ul>
              <li>
                <h3>Purpose:</h3>
                <ul>
                  <li>Briefly explain the purpose of the Cookie Policy (e.g., to inform users about the use of cookies on the website).</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h2>What are Cookies?</h2>
            <ul>
              <li>
                <h3>Definition:</h3>
                <ul>
                  <li>Provide a concise definition of cookies (e.g., small text files stored on the user's device).</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h2>Types of Cookies Used</h2>
            <ul>
              <li>
                <h3>Essential Cookies:</h3>
                <ul>
                  <li>Explain the use of essential cookies for website functionality (e.g., session management, user authentication).</li>
                </ul>
              </li>
              <li>
                <h3>Functionality Cookies:</h3>
                <ul>
                  <li>Explain the use of functionality cookies to enhance user experience (e.g., remembering user preferences, language settings).</li>
                </ul>
              </li>
              <li>
                <h3>Analytics Cookies:</h3>
                <ul>
                  <li>Explain the use of analytics cookies for website tracking and analysis (e.g., Google Analytics).</li>
                </ul>
              </li>
              <li>
                <h3>Advertising Cookies:</h3>
                <ul>
                  <li>Explain the use of advertising cookies for targeted advertising (if applicable).</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h2>Managing Cookie Preferences</h2>
            <ul>
              <li>
                <h3>Browser Settings:</h3>
                <ul>
                  <li>Inform users that they can control cookies through their browser settings (e.g., blocking cookies, deleting cookies).</li>
                </ul>
              </li>
              <li>
                <h3>Cookie Consent Tools:</h3>
                <ul>
                  <li>If using a cookie consent tool, explain how users can adjust their cookie preferences through the tool.</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h2>Changes to this Policy</h2>
            <ul>
              <li>
                <h3>Policy Updates:</h3>
                <ul>
                  <li>Explain that this policy may be updated periodically.</li>
                </ul>
              </li>
            </ul>
        </ol>
      </div>
    </div>
  </div>
</div>
